import React from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
// import { useParams } from 'react-router-dom'
import BookingModify from './bookingModify'
import { EMPTY_OBJECT } from '../../constants/globalConstants'


function BookingCancel(props) { 
  const { notify, partnerDetails } = props
  // const { ticket_id } = useParams()

  return (
    <>
    <BookingModify notify={notify} formType='cancelForm' partnerDetails={partnerDetails}/>
    </>
  )
}

BookingCancel.propTypes = {
  dispatch: PropTypes.func,
  notify: PropTypes.func,
  partnerDetails: PropTypes.object,

}

BookingCancel.defaulProps = {
  dispatch: noop,
  notify: noop,
  partnerDetails: EMPTY_OBJECT,
 
}

function mapStateToProps() {}
export default connect(mapStateToProps)(BookingCancel)
